module.exports = __webpack_public_path__ + "img/restaurant-above.1ab8d9f3.webp";